<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import Jewel05 from './Jewel05.vue'

  export default {
    components: { ItemPage, ItemList, PageChooser, Status },
    mixins: [ Jewel05 ],

    data () {
      return {
        excepts: [ 'だいあコレクション' ],
      }
    },

    computed: {
      itemsPBox () {
        const query = { collection: 'プレゼントボックス' }
        const excepts = [ 'PB-29', 'PB-30', 'PB-31', 'PB-32', 'PB-39', 'PB-40', 'PB-41', 'PB-41:after' ]
        return _
          .where(this.itemsFiltered, query)
          .filter(item => !excepts.includes(item.id))
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[1]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="JR ◆◆◆◆" color="#44cd1f" :items="itemsJR8" />
    </template>

    <template #col2>
      <ItemList title="RR ◆◆◆◆" color="#edd50f" :items="itemsRR" />
      <ItemList title="HR ★★★★" color="#ff5d91" :items="itemsHR" />
      <ItemList title="PR ★★★" color="#ffa1bc" :items="itemsPR" />
    </template>

    <template #col3>
      <ItemList title="PR モーリー限定 ★★★" color="#55b272" :items="itemsMolly" />
      <ItemList title="SR ★★" color="#00c7da" :items="itemsSR" />
      <ItemList title="R ★" color="#feab0d" :items="itemsR" />
      <ItemList title="N" color="#f6c3b2" :items="itemsN" />
    </template>

    <template #col4>
      <ItemList title="パシャッとアイテム" color="#c598ff" :items="itemsPasha" />
      <ItemList title="ブランドランク" color="#c598ff" :items="itemsBrandRank" />
      <ItemList title="プレゼントボックス" color="#c598ff" :items="itemsPBox" />
      <ItemList title="ウィンタースクラッチ" color="#c598ff" :items="itemsWinterScratch" />
    </template>

    <template #col5>
      <ItemList title="ファントミラージュチャンネル" color="#a1c0fa" :items="itemsFMChannel" />
      <ItemList title="すみっコぐらしチャンネル" color="#a1c0fa" :items="itemsSGChannel | first(4)" />
      <ItemList title="クリスマスチャンネル" color="#a1c0fa" :items="itemsXmasChannel" />
      <ItemList title="クーリッシュグレーコーデ スペシャルキャンペーン" color="#a1c0fa" :items="itemsCGCSpecial" />
    </template>

    <template #col6>
      <ItemList title="ジュエルパクト" color="#c598ff" :items="itemsJewelPact" />
      <ItemList title="デザインパレット自作" color="#c598ff" :items="itemsDesignPalette" />
      <Status :date="date" :items="items" :showKira="true" :showHR="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // コレクショングループ間の間隔 (SR)
  .Page ::v-deep .Page__col:nth-child(3) .ItemList:nth-child(2) {
    .Item:nth-child(5),
    .Item:nth-child(6),
    .Item:nth-child(7),
    .Item:nth-child(8) {
      margin-top: $size-unit * 8;
    }
  }

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: 50px;
  //   }
  // }
</style>
